import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { WelcomePackStatusFeatureState } from '../interfaces/shared.interface';
import { WelcomePackStepEnum } from '../../http/welcome-pack/welcome-pack-http.models';
import { WelcomePackAPIActions } from '../actions/welcome-pack.actions';

const initialState: WelcomePackStatusFeatureState = {
  isLoaded: false,
  isCompleted: false,
  currentStep: WelcomePackStepEnum.landing,
  currentStepNumber: 0,
  steps: [],
};

const reducer: ActionReducer<WelcomePackStatusFeatureState> = createReducer(
  initialState,
  on(
    WelcomePackAPIActions.loadedWelcomePackStatusSuccessfully,
    (state, { welcomePackStatus }): WelcomePackStatusFeatureState => {
      let currentStepNumber: number;

      if (welcomePackStatus.currentStep === null) {
        currentStepNumber = 0;
      } else {
        currentStepNumber =
          welcomePackStatus.steps.find(
            (s) => s.name === welcomePackStatus.currentStep,
          )?.number ?? 0;
      }
      return {
        ...welcomePackStatus,
        isLoaded: true,
        currentStepNumber,
      };
    },
  ),
  on(
    WelcomePackAPIActions.updatedWelcomePackStatusSuccessfully,
    (state, { status }): WelcomePackStatusFeatureState => ({
      ...state,
      ...{
        ...status,
        isLoaded: true,
        currentStepNumber:
          status.steps.find((s) => s.name === status.currentStep)?.number ?? 0,
      },
    }),
  ),
);

export function welcomePackStatusReducer(
  state: WelcomePackStatusFeatureState = initialState,
  action: Action,
): WelcomePackStatusFeatureState {
  return reducer(state, action);
}
